<template>
  <div class="webank section" :class="[type]">
    <div class="layout-content">
      <SubTitle :text="data.titleCh" :subText="data.titleEn" />

      <div class="desc">{{ data.desc }}</div>

      <div class="content">
        <FiItem
          class="content-list"
          v-for="(item, index) in data.content.list"
          :key="index"
          :info="item"
          :type="type"
        />
      </div>
    </div>
  </div>
</template>

<script>
import VueTypes from 'vue-types'

import SubTitle from '@/components/SubTitle.vue'
import FiItem from './FiItem.vue'

export default {
  name: 'FiItemWrap',

  components: {
    SubTitle,
    FiItem
  },

  props: {
    data: VueTypes.object.def({}),
    type: VueTypes.string.def('') // is-weight
  }
}
</script>

<style lang="scss" scoped>
.webank {
  background: #F7F8FA;

  &.is-weight {
    background: #fff;

    & .content {
      gap: 0 30px;

      @include mobile {
        gap: 16px 0;
      }
    }
  }
}
.desc {
  width: 819px;
  margin: 22px auto 48px;
  font-size: 20px;
  font-weight: 500;
  color: #404040;
  line-height: 30px;
  text-align: center;

  @include mobile {
    width: auto;
    margin: 0px auto 18px;
    font-size: 12px;
    font-weight: 500;
    color: #404040;
    line-height: 20px;
  }
}
.content {
  display: flex; gap: 0 23px; justify-content: center; align-items: stretch;

  @include mobile {
    flex-direction: column; gap: 16px 0;
  }
}
.content-list {
  width: 253px;

  @include mobile {
    width: auto;
  }
}
</style>
